import React, { useState } from "react";
import "../forcss/enrol.css"
import Header from "../components/Header";
import { Link, useNavigate } from "react-router-dom";

const Enroll = () => {
   const [name,seTname]=useState("")
   const [password,setPassword]=useState("")
  const [email,SetEmail]=useState("")
  
   const navigate = useNavigate()
   
   const toogle=(e)=>{
    e.preventDefault()
    localStorage.setItem("user",JSON.stringify({name,email,password}))
    navigate("/")
     
   }
   
  return (
    <div className="body2">
      <Header/>
  <div className="signup-container">
    <form id="signup-form" className="signup-form" onSubmit={toogle}>
      <h2>Kurslar uchun ruyhatdan uting</h2>
      
      <div className="input-group">
        <label htmlFor="username">Ismingiz</label>
        <input type="text" id="username" name="username" placeholder="Enter your username" value={name} required onChange={(e)=>seTname(e.target.value)}/>
        <small id="username-error" className="error-message"></small>
      </div>

      <div className="input-group">
        <label htmlFor="email">Email</label>
        <input type="email" id="email" name="email" placeholder="Enter your email" value={email} required  onChange={(e)=>SetEmail(e.target.value)}/>
        <small id="email-error" className="error-message"></small>
      </div>

      <div className="input-group">
        <label htmlFor="password">Parol yarating</label>
        <input type="password" id="password" name="password" placeholder="123456789" required value={password}  onChange={(e)=>setPassword(e.target.value)}/>
        <small id="password-error" className="error-message"></small>
      </div>

    
      <button type="submit" className="submit-btn">Ruyhatdan o`tish</button>
<Link to={"/login"}>Have an account?</Link>

    </form>
  </div></div>
  );
};

export default Enroll;